import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const GoogleButton = styled.button`
  width: 100%;
  padding: 15px;
  background: white;
  color: #333;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    border-color: #4285f4;
    box-shadow: 0 5px 15px rgba(66, 133, 244, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const GoogleLoginButton = ({ onSuccess, loading }) => {
  const googleButtonRef = useRef(null);
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '240919788976-se2ahuu4s25h1u99qosv7b1bj7jp1cu6.apps.googleusercontent.com';

  useEffect(() => {
    // Initialize Google Identity Services
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: googleClientId,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: false
      });

      // Render the Google Sign-In button
      if (googleButtonRef.current) {
        window.google.accounts.id.renderButton(
          googleButtonRef.current,
          {
            theme: 'outline',
            size: 'large',
            width: '100%',
            text: 'continue_with',
            shape: 'rectangular'
          }
        );
      }
    }
  }, [googleClientId]);

  const handleCredentialResponse = (response) => {
    try {
      // Send the credential to your backend for verification
      onSuccess(response.credential);
    } catch (error) {
      console.error('Google login failed:', error);
    }
  };

  const handleGoogleLogin = () => {
    // Trigger Google Sign-In popup
    if (window.google) {
      window.google.accounts.id.prompt();
    }
  };

  return (
    <div>
      <div ref={googleButtonRef} style={{ width: '100%' }}></div>
      {/* Fallback button if Google script doesn't load */}
      <GoogleButton 
        onClick={handleGoogleLogin} 
        disabled={loading}
        style={{ display: 'none' }}
      >
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Continue with Google
      </GoogleButton>
    </div>
  );
};

export default GoogleLoginButton;
